// @flow

import React from 'react';
import { FormattedNumber } from 'react-intl';
import {
  Tooltip,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { floorPlanNameTypographySx } from './constants';

export const formatCurrencyCell = (value: number | null | void) =>
  value == null ? (
    '---'
  ) : (
    <FormattedNumber
      value={value}
      style="currency"
      currency="USD"
      minimumFractionDigits={2}
    />
  );

type FloorPlanNameProps = {|
  name: string,
|};

export const FloorPlanName = ({ name }: FloorPlanNameProps) => (
  <Tooltip title={name}>
    <Typography
      variant="bodySmall"
      component="span"
      noWrap
      sx={floorPlanNameTypographySx}
    >
      {name}
    </Typography>
  </Tooltip>
);
